import { render } from "./Theme.vue?vue&type=template&id=592c38f1"
import script from "./Theme.vue?vue&type=script&lang=js"
export * from "./Theme.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.13.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__